import axios from "axios";
import { API_ENDPOINT, TOKEN_KEY } from "../config";
import Cookies from "universal-cookie";

// const cookies = new Cookies();
const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

export const addPricing = async (data) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  for (var key in data) {
    if (Array.isArray(data[key])) {
      fd.append(key, JSON.stringify(data[key]));
    } else {
      fd.append(key, data[key]);
    }
  }
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}product/price/create`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const handleUpdatePricingStatus = async (data) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  for (var key in data) {
    fd.append(key, data[key]);
  }
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}product/price/update_stock_status`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};
export const handleDiscountStatus = async (data) => {
  let fd = new FormData();
  for (var key in data) {
    fd.append(key, data[key]);
  }
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}product/price/update_daily_discount`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};
export const deletePricing = async (price_id) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  fd.append("price_id", price_id);
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}product/price/delete`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};
